import React, { Component } from 'react';
import About from './About/About';
import Work from './Posts/Work';
import PostFull from './Posts/PostFull';
import Photo from './PhotoJournal/Photo';
import ScrollToTop from './ScrollToTop';
import './assets/css/App.css';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import { generateKey, removeSpacing } from './utils/utils.js';
import Navigation from './Nav/Nav'
import { getHomepageData, getNavigationData } from './Queries'

class RouterIndex extends Component {
	state = {
		allContent: [],
		isMobile: '',
		is_chrome: '',
		homepageMobilePosts: [],
		filter: null,
		page: ''
	};

	componentDidMount() {
		this.fetchHomepageAndNavigation()
	}

	fetchHomepageAndNavigation = () => {
		let is_chrome = '';
		let isMobile = '';
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
			is_chrome = navigator.userAgent.match('CriOS') ? 'isMobileChrome' : 'not__chrome';
			isMobile = 'mobileDevice'
		}

		getHomepageData()
			.then((res) => {
				if (!res.items || !res.items[0]) {
					this.setState({ loadError: true, isMobile, is_chrome });
					return;
				}
				const { homepagePosts = [], footerText, homepageMobilePosts, mobileVideo, mobileVideoThumbnail } = res.items[0].fields;
				this.setState({
					allContent: homepagePosts,
					footerText,
					homepageMobilePosts,
					isMobile,
					is_chrome,
					mobileVideo,
					mobileVideoThumbnail,
					page: window.location.pathname
				});
			})
			.catch((err) => {
				console.error('getHomepageData failed', err);
				this.setState({ loadError: true, isMobile, is_chrome });
			});

		getNavigationData()
			.then((res) => {
				const favIconUrl = res && res.items && res.items[0]
					&& res.items[0].fields && res.items[0].fields.favicon
					&& res.items[0].fields.favicon.fields
					&& res.items[0].fields.favicon.fields.file
					&& res.items[0].fields.favicon.fields.file.url;
				if (!favIconUrl) return;
				const favicon = document.getElementById('favicon');
				if (favicon) favicon.href = favIconUrl;
			})
			.catch((err) => {
				console.error('getNavigationData failed', err);
			});
	}

	setFilter = (filter) => {
		this.setState({ filter })
	}

	updateLocation = () => {
		this.setState({ page: window.location.pathname })
	}

	render() {

		let allPostRoutes = this.state.allContent.map((postContent, index) => {
			if (postContent.fields && postContent.fields.title) {
				return (
					<Route
						key={generateKey(index)}
						path={`/project/${removeSpacing(postContent.fields.title)}`}
						render={() => (
							<PostFull
								nextPost={this.state.allContent[index + 1]}
								postContent={postContent}
								allContent={this.state.allContent}
								footerText={this.state.footerText}
								updateLocation={this.updateLocation}
							/>
						)}
					/>
				);
			} else {
				return null;
			}
		});

		return (
			<Router>
				<Route
					render={({ location }) => {
						return (
							<div className={`router ${this.state.isMobile} ${this.state.is_chrome} ${location.pathname.includes('project') ? 'project-full' : ''}`}>
								<header className={`App-header `}>
									<Navigation
										page={location}
										setFilter={this.setFilter}
										location={location}
										allContent={this.state.allContent} />
								</header>
								<ReactCSSTransitionReplace
									transitionName="navigation"
									transitionEnterTimeout={50}
									transitionLeaveTimeout={50}
								>
									<div key={location.pathname}>
										<ScrollToTop />
										<Switch location={location}>
											<Route
												path="/"
												exact
												render={() => (
													<Work
														allContent={this.state.allContent}
														filter={this.state.filter}
														footerText={this.state.footerText}
														homepageMobilePosts={this.state.homepageMobilePosts}
														updateLocation={this.updateLocation}
														mobileVideo={this.state.mobileVideo}
														mobileVideoThumbnail={this.state.mobileVideoThumbnail}
													/>
												)}
											/>
											<Route path="/about" component={About} />
											<Route
												path="/photo"
												render={() => (
													<Photo
														footerText={this.state.footerText}
														allContent={this.state.allContent}
													/>
												)}
											/>
											{allPostRoutes}
										</Switch>
									</div>
								</ReactCSSTransitionReplace>
							</div>
						)
					}
					}
				/>
			</Router>
		);
	}
}

export default RouterIndex;



// WEBPACK FOOTER //
// ./src/Route.js